module.exports = __webpack_public_path__ + "img/202104191939565530v8.e17edd6d.png";